import type { CurrentUser } from '@hotjar/user';
import type { Organization } from '@hotjar/organization';
import type { MfeCurrentUserData, MfeUserPermissions } from '../types';

export function mapCurrentUserToMfe(
  user?: CurrentUser,
  organization?: Organization,
  permissions: MfeUserPermissions | null = null,
): MfeCurrentUserData | undefined {
  if (!user) return undefined;
  return {
    id: user.id,
    name: user.name,
    email: user.email,
    currentOrg: organization ? { id: organization.id, name: organization.name } : null,
    permissions,
  };
}
